import React, { useState, useEffect, createRef } from "react";
import {
  makeStyles,
  Button,
  Box,
  FormControl,
  InputLabel,
  MenuItem,
  DialogActions,
  Dialog,
  DialogContent,
  Typography,
  IconButton,
  withStyles,
  Slide,
  Grid,
} from "@material-ui/core";

import { Formik, Form, Field } from "formik";
import CustomSelectInput from "./../../inputs/CustomSelectInput";

import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import SearchIcon from "@material-ui/icons/Search";
import MuiDialogTitle from "@material-ui/core/DialogTitle";

import MaterialTable from "material-table";
import { useDispatch, useSelector } from "react-redux";
import { getDepts } from "src/redux/actions/department.action";
import {
  clearProductItem,
  getAllProjects,
  getProduct,
} from "src/redux/actions/product.action";
import { getBrands } from "src/redux/actions/brand.action";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 600,
    padding: 1,
  },
  inputForm: {
    margin: theme.spacing(1, 1, 1),
    width: "25ch",
  },
  buttonForm: {
    margin: theme.spacing(0, 1, 0),
    lineHeight: "5ch",
    alignContent: "center",
  },
}));

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    overflowX: "auto",
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "25ch",
    },
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ProductItemJobModal({
  open,
  handleClose,
  isLoading,
  handleAdd,
  countryid,
  companyid,
  secureid,
  budgetcode,
  year,
}) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const brandReducer = useSelector((state) => state.brandReducer);

  const departmentReducer = useSelector((state) => state.departmentReducer);

  const { products } = useSelector((state) => state.productReducer);

  const [brand, setBrand] = useState(null);
  const [department, setDepartment] = useState(null);

  const [rowSelect, setRowSelect] = useState({
    tableRef: createRef(),
    selected: true,
    selectedRowId: null,
    c: "blue",
    currentRow: {},
  });

  useEffect(() => {
    if (open) {
      dispatch(clearProductItem());
      dispatch(getBrands(countryid, companyid, secureid));
    }
    return () => {};
  }, [open]);

  const renderBrandItem = () => {
    if (brandReducer.isFetching) {
      return <MenuItem>Loading...</MenuItem>;
    }
    return brandReducer.result.map((item) => (
      <MenuItem key={item.ORG_BRAND_ID} value={item.ORG_BRAND_ID}>
        {item.BRAND}
      </MenuItem>
    ));
  };

  const renderDepartment = () => {
    if (departmentReducer.isFetching) {
      return <MenuItem>Loading...</MenuItem>;
    }

    return departmentReducer.result.map((item) => (
      <MenuItem
        MenuItem={item.ORG_DEPARTMENT_ID}
        value={item.ORG_DEPARTMENT_ID}
      >
        {item.department}
      </MenuItem>
    ));
  };

  const handleChangeBrand = (event) => {
    dispatch(getDepts(countryid, companyid, secureid, event.target.value));
  };

  const renderProduct = (item) => {
    if (budgetcode) {
      return _.filter(item, { ACC_CODE: budgetcode });
    } else {
      return item;
    }
  };

  return (
    <div className={classes.modal}>
      <Dialog
        fullScreen
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        TransitionComponent={Transition}
        open={open}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Adjust Item
        </DialogTitle>
        <DialogContent dividers>
          <Grid>
            <Formik
              initialValues={{
                PR_BRANDID: "",
                PR_DEPARTID: "",
              }}
              validate={(values) => {
                const errors = {};

                if (!values.PR_BRANDID) {
                  errors.PR_BRANDID = "Required";
                }

                if (!values.PR_DEPARTID) {
                  errors.PR_DEPARTID = "Required";
                }

                return errors;
              }}
              onSubmit={(values, { setSubmitting }) => {
                dispatch(
                  getProduct(
                    countryid,
                    values.PR_DEPARTID,
                    values.PR_BRANDID,
                    year
                  )
                );

                setSubmitting(false);
              }}
              render={({
                submitForm,
                isSubmitting,
                setSubmitting,
                touched,
                errors,
                values,
                setFieldValue,
              }) => (
                <>
                  <FormControl variant="outlined" className={classes.inputForm}>
                    <InputLabel
                      id="select-brand-label"
                      error={Boolean(
                        errors.PR_BRANDID &&
                          touched.PR_BRANDID &&
                          errors.PR_BRANDID
                      )}
                    >
                      Brand
                    </InputLabel>
                    <Field
                      component={CustomSelectInput}
                      name="PR_BRANDID"
                      label="Brand"
                      labelId="select-brand-label"
                      size="small"
                      error={Boolean(
                        errors.PR_BRANDID &&
                          touched.PR_BRANDID &&
                          errors.PR_BRANDID
                      )}
                      onChange={handleChangeBrand}
                    >
                      {renderBrandItem()}
                    </Field>
                  </FormControl>
                  <FormControl variant="outlined" className={classes.inputForm}>
                    <InputLabel
                      error={Boolean(
                        errors.PR_DEPARTID &&
                          touched.PR_DEPARTID &&
                          errors.PR_DEPARTID
                      )}
                      id="select-depart-label"
                    >
                      Department
                    </InputLabel>
                    <Field
                      component={CustomSelectInput}
                      name="PR_DEPARTID"
                      label="Department"
                      labelId="select-depart-label"
                      size="small"
                      onChange={() => {}}
                      error={Boolean(
                        errors.PR_DEPARTID &&
                          touched.PR_DEPARTID &&
                          errors.PR_DEPARTID
                      )}
                    >
                      {renderDepartment()}
                    </Field>
                  </FormControl>
                  <FormControl className={classes.inputForm}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={submitForm}
                      className={classes.buttonForm}
                      disabled={isSubmitting}
                    >
                      <SearchIcon />
                      Search
                    </Button>
                  </FormControl>
                </>
              )}
            />
          </Grid>
          <Box display="flex" component="div" flexDirection="column">
            <Box>
              <MaterialTable
                title
                columns={[
                  {
                    title: "Budget Code",
                    field: "ACC_CODE",
                  },
                  { title: "Items Code", field: "STYLECODE" },
                  {
                    title: "Item Name",
                    field: "NAME_TH",
                    cellStyle: {
                      whiteSpace: "nowrap",
                    },
                  },
                  {
                    title: "Description",
                    field: "DESCRIP_TH",
                    cellStyle: {
                      whiteSpace: "nowrap",
                    },
                  },
                  { title: "Items Code", field: "UNIT_NAME", hidden: true },
                  {
                    title: "Detail",
                    field: "ACCDETAIL",
                    cellStyle: {
                      minWidth: 600,
                      whiteSpace: "nowrap",
                    },
                  },
                ]}
                data={renderProduct(products.data)}
                isLoading={products.isLoading}
                options={{
                  pageSize: 10,
                  detailPanelType: "single",
                  rowStyle: (rowData) => {
                    let selected =
                      rowSelect.selectedRow &&
                      rowSelect.selectedRow.tableData.id ===
                        rowData.tableData.id;
                    return {
                      backgroundColor: selected ? "grey" : "#FFF",
                      color: selected ? "#e0dd1f !important" : "#000",
                    };
                  },
                }}
                onRowClick={(evt, selectedRow) => {
                  const {
                    BUDGETS_DEPARTMENT,
                    BUDGETS_BRAND,
                    BGIDX,
                    BUDGETP_ID,
                  } = selectedRow;
                  if (BUDGETP_ID > 0) {
                    dispatch(
                      getAllProjects(
                        countryid,
                        BUDGETS_DEPARTMENT,
                        BUDGETS_BRAND,
                        year,
                        BGIDX
                      )
                    );
                  }

                  setRowSelect({ selectedRow });
                }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            variant="contained"
            disabled={isLoading}
            color="primary"
            onClick={(e) => {
              e.preventDefault();
              if (rowSelect.selectedRow) {
                handleAdd(rowSelect.selectedRow);
                setRowSelect({
                  tableRef: createRef(),
                  selected: true,
                  selectedRowId: null,
                  c: "blue",
                  currentRow: {},
                });
              }
              handleClose();
            }}
          >
            <SaveIcon />
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
